export default "__VITE_ASSET__0b3bca57__"